


export function toHumanReadableTime(time: number): string {
    if (time < 1000) {
        return `${time} ms`;
    } else if (time < 60 * 1000) {
        return `${(time / 1000).toFixed(2)} s`;
    } else if (time < 60 * 60 * 1000) {
        return `${(time / (60 * 1000)).toFixed(2)} min`;
    } else if (time < 24 * 60 * 60 * 1000) {
        return `${(time / (60 * 60 * 1000)).toFixed(2)} h`;
    }
    else if (time < 7 * 24 * 60 * 60 * 1000) {
        return `${(time / (24 * 60 * 60 * 1000)).toFixed(2)} d`;
    }
    else if (time < 30 * 24 * 60 * 60 * 1000) {
        return `${(time / (7 * 24 * 60 * 60 * 1000)).toFixed(2)} w`;
    }
    else if (time < 365 * 24 * 60 * 60 * 1000) {
        return `${(time / (30 * 24 * 60 * 60 * 1000)).toFixed(2)} mo`;
    }
    else {
        return `${(time / (365 * 24 * 60 * 60 * 1000)).toFixed(2)} y`;
    }
}

export function toHumanReadableTimePassedSinceNow(pastTimestamp: number, postfix: string = "ago"): string {
    const now = Date.now();
    const diff = now - pastTimestamp;
    let humanReadableTime = _formatTimeDifference(diff);
    if (postfix) {
        return `${humanReadableTime} ${postfix}`;
    }
    return humanReadableTime;
}


function _formatTimeDifference(diff: number): string {
    if (diff < 1000) {
        return `${diff} ms`;
    } else if (diff < 60 * 1000) {
        return `${Math.floor(diff / 1000)} sec`;
    } else if (diff < 60 * 60 * 1000) {
        return `${Math.floor(diff / (60 * 1000))}min`;
    } else if (diff < 24 * 60 * 60 * 1000) {
        return `${Math.floor(diff / (60 * 60 * 1000))} hour`;
    }
    else if (diff < 7 * 24 * 60 * 60 * 1000) {
        return `${Math.floor(diff / (24 * 60 * 60 * 1000))} day`;
    }
    else if (diff < 30 * 24 * 60 * 60 * 1000) {
        return `${Math.floor(diff / (7 * 24 * 60 * 60 * 1000))} week`;
    }
    else if (diff < 365 * 24 * 60 * 60 * 1000) { // less than a year
        return `${Math.floor(diff / (30 * 24 * 60 * 60 * 1000))} month`;
    }
    else {
        return `A long time ago`;
    }
}



type HumanReadableOptions = {
    round?: boolean;
    ceil?: boolean;
}
export function toHumanReadableBytes(bytes: number, decimals: number = 2, options?: HumanReadableOptions): string {
    if (typeof bytes !== 'number' || isNaN(bytes)) {
        return "N/A";
    }
    if (bytes < 1024) {
        return `${applyOptions(bytes, options)} B`;
    } else if (bytes < 1024 * 1024) {
        return `${applyOptions((bytes / 1024), options).toFixed(decimals)} KB`;
    } else if (bytes < 1024 * 1024 * 1024) {
        return `${applyOptions((bytes / (1024 * 1024)), options).toFixed(decimals)} MB`;
    } else {
        return `${applyOptions((bytes / (1024 * 1024 * 1024)), options).toFixed(decimals)} GB`;
    }
}
function applyOptions(value: number, options?: HumanReadableOptions): number {
    if (options?.round) {
        return Math.round(value);
    }
    else if (options?.ceil) {
        return Math.ceil(value);
    }
    return value;
}


export function toMaxFixed(value: number, maxDecimals: number = 2): string {
    const fixed = value.toFixed(maxDecimals);
    return String(parseFloat(fixed));
}